/**
 * Reference to the Redux store, set once at app entry. Use this instead of
 * importing store in any module that is reachable from reducers or store
 * creation (e.g. apiHandler, Helper, dashboardService, applicationServiceBase)
 * to avoid circular dependencies. Do not import store in this file.
 */
let storeRef = null;

export function setStore(store) {
  storeRef = store;
}

export function getStore() {
  if (!storeRef) {
    throw new Error("Something went wrong. Please refresh the page.");
  }
  return storeRef;
}
